import React from 'react'

import AccountsList from '../../components/accountsList/AccountsList'

const UsersAccounts = props => <AccountsList {...props} />

export default UsersAccounts
